import React, { useRef } from "react";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calender.svg";
import "../../../css/DesignSystem/Inputs/DateTimeField.css";

const AnnouncementDateTimeField = ({
  label,
  date,
  time,
  onDateChange,
  onTimeChange,
  disabled = false,
  required = false,
}) => {
  const dateInputRef = useRef(null);
  const timeInputRef = useRef(null);

  const openDatePicker = () => {
    if (disabled) return;

    if (dateInputRef.current?.showPicker) {
      dateInputRef.current.showPicker();
    } else {
      dateInputRef.current?.focus();
    }
  };

  const openTimePicker = () => {
    if (disabled) return;

    if (timeInputRef.current?.showPicker) {
      timeInputRef.current.showPicker();
    } else {
      timeInputRef.current?.focus();
    }
  };

  return (
    <div className="announcement-date-time-field">
      <label className="fp-form-label FP_Body">
        {label}{" "}
        {required && <span className="FP_Content_Semibold text-error">*</span>}
      </label>

      <div className="announcement-date-time-row">
        <div className="announcement-date-input-wrap">
          <input
            ref={dateInputRef}
            type="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            className="FP_Content fp-form-input announcement-date-input"
            disabled={disabled}
          />

          <button
            type="button"
            className="announcement-date-picker-button"
            onClick={openDatePicker}
            disabled={disabled}
            aria-label="Open calendar"
          >
            <CalendarIcon />
          </button>
        </div>

        <div className="announcement-time-input-wrap">
          <input
            ref={timeInputRef}
            type="time"
            value={time}
            onChange={(e) => onTimeChange(e.target.value)}
            className="FP_Content fp-form-input announcement-time-input"
            disabled={disabled}
          />

          <button
            type="button"
            className="announcement-time-picker-button"
            onClick={openTimePicker}
            disabled={disabled}
            aria-label="Open time picker"
          >
            ⏱
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDateTimeField;
